import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};
export const bookingAPI = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getBookingList: builder.query<
      CommonResponse,
      { page?: number; limit?: number; search?: string; paymentType?: number; status?: number }
    >({
      query: (params) => {
        const newParams: any = { ...params };
        if (!newParams.search) delete newParams.search;
        if (!newParams.paymentType) delete newParams.paymentType;
        if (!newParams.status) delete newParams.status;
        return {
          url: END_POINTS.bookingList,
          method: "GET",
          params: newParams,
        }
      },
    }),

    getBookingDetailsById: builder.query<CommonResponse, { id: string | undefined }>({
      query: ({ id }) => ({
        url: `${END_POINTS.bookingDetailsById}/${id}`,
        method: "GET",
      }),
    }),
    getBookingStats: builder.query<CommonResponse, void>({
      query: () => ({
        url: `${END_POINTS.bookingStats}`,
        method: "GET",
      }),
    }),
    updateBookingStatus: builder.mutation<CommonResponse, { id: string; body: any }>({
      query: ({ id, body }) => ({
        url: `${END_POINTS.bookingUpdate}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    submitBooking: builder.mutation<CommonResponse, { id: string, body: any }>({
      query: ({ id, body }) => ({
        url: `${END_POINTS.bookingDetailsById}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    bookingExportCsv: builder.query<CommonResponse, { search?: string; paymentType?: number; status?: number }>({
      query: (params) => {
        const newParams: any = { ...params, isExport: 1 };
        if (!newParams.search) delete newParams.search;
        if (!newParams.paymentType) delete newParams.paymentType;
        if (!newParams.status) delete newParams.status;
        return {
          url: END_POINTS.bookingExportCsv,
          method: "GET",
          params: newParams,
        }
      },
    }),
  }),
});
export const {
  useLazyGetBookingListQuery,
  useLazyGetBookingDetailsByIdQuery,
  useGetBookingStatsQuery,
  useUpdateBookingStatusMutation,
  useSubmitBookingMutation,
  useLazyBookingExportCsvQuery
} = bookingAPI;
